<template>
  <custom-dropdown
    :key="dropdownKey"
    :list="normalizedList"
    :selected="selectedOption"
    :default-label="'content...'"
    :default-style="defaultStyle"
    prevent-deselection
    @select="selectItem"
  />
</template>

<script>
import CustomDropdown from '@/components/common/customDropdown.vue'
import { optionValue } from '../conditionHelper'

export default {
  name: 'ConfigListElement',
  components: {
    CustomDropdown
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    defaultStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    normalizedList () {
      return this.list.map(item => {
        if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
          return { id: item, name: String(item), value: item }
        }
        return {
          ...item,
          id: item.id ?? item.value ?? item.name,
          name: item.name ?? item.value ?? item.id
        }
      })
    },
    selectedOption () {
      const selectedValue = optionValue(this.value)
      return this.normalizedList.find(item => optionValue(item) === selectedValue) || {}
    },
    dropdownKey () {
      const selectedValue = optionValue(this.value)
      return `${selectedValue ?? 'empty'}-${this.normalizedList.length}`
    }
  },
  methods: {
    selectItem (item) {
      this.$emit('input', item)
    }
  }
}
</script>
